module.exports = __webpack_public_path__ + "static/media/wrangler-hero.658013be.jpg";